import React from 'react';
import SelectButtons from './SelectButtons';
import {
  StyledAsterisksText,
  SubSection,
  FormSection,
} from '@/shared/styles/styledComponents/editProfileForm';
import { StylingPreference } from '@/shared/types/stylist';
import { ButtonSelectItem } from '@/shared/styles/types';

interface ExpertiseSectionProps {
  selectedStylingPreference: ButtonSelectItem[];
  setSelectedStylingPreference: React.Dispatch<
    React.SetStateAction<ButtonSelectItem[]>
  >;
}

const ClientAesthetics: React.FC<ExpertiseSectionProps> = ({
  selectedStylingPreference,
  setSelectedStylingPreference,
}) => {
  return (
    <FormSection marginBottom={42}>
      <SubSection>
        <StyledAsterisksText>Current Aesthetics*</StyledAsterisksText>
        <SelectButtons
          setSelectedItems={setSelectedStylingPreference}
          selectedItems={selectedStylingPreference}
          enumArray={Object.values(StylingPreference)}
        />
      </SubSection>
    </FormSection>
  );
};

export default ClientAesthetics;
